import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInventories } from './store/slice';
import { fetchAllProcessStatuses } from '../../core/redux/status/slice';
import { fetchCustomers } from '../../core/redux/customer/slice';
import InventoryTopHead from './inventory-top-head';
import InventoryContent from './inventory-content';
import InventoryModals from './inventory-modals';
import { actions as inventoryActions } from './store/slice';
const { resetFilters } = inventoryActions;

const InventoryView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchInventories({}));
    // dispatch(fetchStatuses());
    dispatch(fetchCustomers({}));
    dispatch(fetchAllProcessStatuses());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Inventory</h4>
              </div>
            </div>
            <InventoryTopHead />
          </div>
          <InventoryContent />
          <InventoryModals />
        </div>
      </div>
    </div>
  );
};

export default InventoryView;
